import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../lib/seo';
import { ContactForm } from '../components/ContactForm';

export function Products({ settings }) {
  const phone = settings?.phone || "82 82 10 10";
  const rawPhone = phone.replace(/\s+/g, '');

  const problemsList = [
    { label: "Lugtende fødder", icon: "fa-solid fa-wind" },
    { label: "Svedige fødder", icon: "fa-solid fa-droplet" },
    { label: "Hård hud", icon: "fa-solid fa-hand-sparkles" },
    { label: "Tør hud", icon: "fa-solid fa-shield-heart" },
    { label: "Kolde fødder", icon: "fa-solid fa-fire-flame-curved" },
    { label: "Varme fødder", icon: "fa-solid fa-snowflake" },
    { label: "Irriteret hud", icon: "fa-solid fa-heart-pulse" },
    { label: "Sårpleje", icon: "fa-solid fa-kit-medical" },
  ];

  return (
    <>
      <SEO 
        title="Produkter & Cremer | Fodtid - Den Glade Fodmand"
        description="Bredt udvalg af naturlige cremer til lugtende, svedige, kolde eller tørre fødder. 100% naturlige urter og olier uden parabener og kemi."
      />

      {/* Header */}
      <section className="bg-canvas py-14 sm:py-20 border-b border-brand-border">
        <div className="max-w-4xl mx-auto px-4 sm:px-8 text-center space-y-4">
          <span className="text-xs uppercase font-bold tracking-widest text-brand-charcoal bg-surface px-4 py-1.5 rounded-full border border-brand-border inline-block">
            100 % Naturlige Urter & Olier
          </span>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-brand-charcoal">
            Produkter & Cremer
          </h1>
          <p className="text-brand-muted text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            De fleste af vores cremer er lavet af 100 % naturlige urter og olier – helt fri for skadelige kemikalier og parabener.
          </p>
        </div>
      </section>

      {/* Cremer Section */}
      <section className="py-14 sm:py-20 bg-canvas border-b border-brand-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            
            {/* Left: Content */}
            <div className="lg:col-span-6 space-y-6">
              <div className="space-y-3">
                <span className="text-xs uppercase font-bold tracking-widest text-brand-muted">
                  Specialpleje
                </span>
                <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-bold text-brand-charcoal">
                  Jeg tilbyder et bredt udvalg af cremer
                </h2>
                <p className="text-brand-muted text-base leading-relaxed">
                  Vores specialudviklede urtecremer kan hjælpe med en lang række udfordringer – eller hvis du bare vil have bløde, sunde fødder:
                </p>
              </div>

              {/* Grid of issues */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
                {problemsList.map((item, idx) => (
                  <div 
                    key={idx} 
                    className="flex items-center gap-3 p-3.5 rounded-xl bg-surface/60 border border-brand-border"
                  >
                    <div className="w-8 h-8 rounded-full bg-brand-charcoal text-canvas flex items-center justify-center shrink-0 text-xs">
                      <i className={item.icon} aria-hidden="true" />
                    </div>
                    <span className="text-sm font-semibold text-brand-charcoal">{item.label}</span>
                  </div>
                ))}
              </div>

              <div className="p-5 rounded-2xl bg-surface/40 border border-brand-border space-y-2">
                <h3 className="font-serif text-lg font-bold text-brand-charcoal">
                  Køb til fordelagtig indkøbspris
                </h3>
                <p className="text-sm text-brand-muted leading-relaxed">
                  Du kan købe de produkter, vi bruger i behandlingerne, til fordelagtig indkøbspris direkte ved dit hjemmebesøg eller bestille dem her.
                </p>
              </div>
            </div>

            {/* Right: Images from scrape */}
            <div className="lg:col-span-6 space-y-6">
              <div className="rounded-3xl overflow-hidden shadow-md border border-brand-border bg-surface">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/d4428667-cde9-4c31-9224-88278506a01a/cropped-skaermbillede-2025-09-03-kl-17-07-56_412ac53e.png"
                  alt="fodbehandling, fodterapi, fodpleje, hård hud, ligtorne, hælsporer, fodindlæg, fodterapeut, diabetes fodpleje, fodklinik"
                  className="w-full h-auto object-cover"
                />
              </div>

              <div className="rounded-3xl overflow-hidden shadow-sm border border-brand-border bg-surface">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/d4428667-cde9-4c31-9224-88278506a01a/skaermbillede-2025-09-04-kl-01-07-55-2048x475.png"
                  alt="Specialcremer og naturlige produkter"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Testimonial Quote & Info Callout */}
      <section className="py-12 bg-surface/50 border-b border-brand-border">
        <div className="max-w-4xl mx-auto px-4 sm:px-8 text-center space-y-4">
          <i className="fa-solid fa-quote-left text-2xl text-brand-muted/50" aria-hidden="true" />
          <blockquote className="font-serif text-lg sm:text-xl md:text-2xl text-brand-charcoal italic leading-relaxed">
            ”Else, Frederikssund 90 år – Venlig og meget dygtig til sit arbejde.”
          </blockquote>
          <p className="text-sm font-semibold text-brand-muted">
            Lad mig hjælpe dig med at give dine fødder den pleje, de fortjener!
          </p>
        </div>
      </section>

      {/* Practical Details & Bestil */}
      <section className="py-14 sm:py-20 bg-canvas">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
            
            {/* Left: Contact Info & Area */}
            <div className="lg:col-span-5 space-y-6">
              <div className="bg-surface/50 rounded-3xl p-6 sm:p-8 border border-brand-border space-y-6">
                <div>
                  <span className="text-xs uppercase font-bold tracking-widest text-brand-muted">
                    Bestilling & Tidsbestilling
                  </span>
                  <h2 className="font-serif text-2xl sm:text-3xl font-bold text-brand-charcoal mt-1">
                    Bestil din creme
                  </h2>
                </div>

                <p className="text-brand-muted text-sm leading-relaxed">
                  Ring på <strong className="text-brand-charcoal">{phone}</strong> for at bestille tid eller produkter. Jeg kører ud mandag til lørdag fra kl. 9-18.
                </p>

                <div className="pt-2">
                  <a
                    href={`tel:${rawPhone}`}
                    className="inline-flex items-center gap-3 bg-brand-charcoal text-canvas px-6 py-3.5 rounded-full font-bold text-sm hover:opacity-90 transition-opacity shadow-sm"
                  >
                    <i className="fa-solid fa-phone" aria-hidden="true" />
                    <span>Ring {phone}</span>
                  </a>
                </div>

                <div className="border-t border-brand-border pt-6 space-y-4">
                  <div>
                    <h3 className="text-xs font-bold uppercase tracking-wider text-brand-charcoal mb-2">
                      Område for Hjemmebesøg
                    </h3>
                    <ul className="text-sm text-brand-muted space-y-1">
                      <li className="flex items-center gap-2">
                        <i className="fa-solid fa-location-dot text-brand-accent text-xs" aria-hidden="true" />
                        <span>Hele Sjælland (minus øerne)</span>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h3 className="text-xs font-bold uppercase tracking-wider text-brand-charcoal mb-2">
                      Åbningstider
                    </h3>
                    <div className="text-sm text-brand-muted">
                      <strong className="text-brand-charcoal">MAN - LØR:</strong> 9:00 - 18:00
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Contact Form */}
            <div className="lg:col-span-7">
              <div className="bg-surface/30 rounded-3xl p-6 sm:p-10 border border-brand-border">
                <div className="mb-6 space-y-1">
                  <h2 className="font-serif text-2xl font-bold text-brand-charcoal">
                    Send en besked eller bestilling
                  </h2>
                  <p className="text-xs sm:text-sm text-brand-muted">
                    Udfyld formularen, så vender vi hurtigt tilbage til dig.
                  </p>
                </div>
                <ContactForm initialService="Bestilling af cremer & produkter" />
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
